/**
 * Logo NewEra, thiết kế dòng 583 (`width:26px;height:26px;display:block`).
 *
 * Inline thành component thay vì thẻ ảnh: yêu cầu R1 (design doc §5) — module dựng bằng React —
 * và inline thì không thêm một request nào.
 *
 * `viewBox` KHÔNG vuông (209.066 × 182.933) đúng như file gốc. Giữ nguyên: `preserveAspectRatio`
 * mặc định sẽ letterbox trong khung 26×26, đúng thứ thiết kế đang hiển thị. Đổi viewBox cho
 * "vuông đẹp" là bóp méo logo.
 *
 * File gốc tô cứng màu thương hiệu; ở đây dùng `currentColor` để chỗ dùng đặt màu bằng class
 * token, vì cổng `check-classes` cấm hex trong component.
 */
export function NewEraMark({ className }: { readonly className?: string }) {
  return (
    <svg
      width={26}
      height={26}
      viewBox="0 0 209.066 182.933"
      fill="currentColor"
      aria-hidden
      className={className}
    >
      <path
        fillRule="nonzero"
        d="M 4.417 91.16 C 2.303 91.16 0.86 93.297 1.65 95.257 L 28.807 162.709 C 29.262 163.839 30.362 164.588 31.578 164.53 C 58.785 163.219 76.985 135.54 66.724 110.041 L 62.746 100.166 C 61.127 96.147 64.107 91.772 68.461 91.772 L 72.821 91.772 C 75.34 91.772 77.606 93.296 78.536 95.621 L 112.941 181.064 C 113.396 182.193 114.499 182.941 115.715 182.894 C 149.998 181.573 173.035 146.791 160.145 114.764 L 154.264 100.16 C 152.644 96.141 155.625 91.772 159.979 91.772 L 204.649 91.772 C 206.762 91.772 208.206 89.635 207.416 87.675 L 180.259 20.223 C 179.804 19.094 178.704 18.344 177.488 18.403 C 150.281 19.714 132.081 47.393 142.341 72.886 L 146.32 82.772 C 147.939 86.792 144.959 91.16 140.605 91.16 L 135.629 91.16 C 133.11 91.16 130.844 89.637 129.914 87.312 L 95.515 1.869 C 95.061 0.74 93.958 -0.008 92.741 0.039 C 58.458 1.36 35.421 36.141 48.311 68.168 L 54.192 82.772 C 55.812 86.792 52.832 91.16 48.478 91.16 L 4.417 91.16 Z"
      />
    </svg>
  );
}
